export default __webpack_public_path__ + "static/illustration-content-title.url-ec3bb005f0c9903b184a48bcca8a4758.svg";